/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentDetailsShouldShowPayeesViewModel
 */
export interface PaymentDetailsShouldShowPayeesViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsShouldShowPayeesViewModel
     */
    hasPayees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsShouldShowPayeesViewModel
     */
    arePayeesAllowed: boolean;
}

/**
 * Check if a given object implements the PaymentDetailsShouldShowPayeesViewModel interface.
 */
export function instanceOfPaymentDetailsShouldShowPayeesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "arePayeesAllowed" in value;

    return isInstance;
}

export function PaymentDetailsShouldShowPayeesViewModelFromJSON(json: any): PaymentDetailsShouldShowPayeesViewModel {
    return PaymentDetailsShouldShowPayeesViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsShouldShowPayeesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsShouldShowPayeesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasPayees': !exists(json, 'HasPayees') ? undefined : json['HasPayees'],
        'arePayeesAllowed': json['ArePayeesAllowed'],
    };
}

export function PaymentDetailsShouldShowPayeesViewModelToJSON(value?: PaymentDetailsShouldShowPayeesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'HasPayees': value.hasPayees,
        'ArePayeesAllowed': value.arePayeesAllowed,
    };
}

